export default "__VITE_ASSET__CYQkk9nQ__"